
<div mat-dialog-title>
  <div class='text-right line-height-0'>
    <button class="btnclose" tabindex="-1" [mat-dialog-close]></button>
  </div>
  <div class="col-12 popupTitle_rules p-0">
    <span class="col-12 p-0">Filter Columns</span>
  </div>
  
</div>
<mat-dialog-content>
  <form [formGroup]="filterGroup">
    <div class="row">
      <div class="col-12" formArrayName="filterControls"
        *ngFor="let item of filterGroup.get('filterControls')['controls']; let i = index;">
        <div class="row" [formGroupName]="i">
          <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
            <mat-form-field class="col-12">
              <mat-select placeholder="Column Name" formControlName="coloumnName"
                (selectionChange)="setFilterType($event,i, false)" required>
                <mat-option value="">Select Column Name</mat-option>
                <mat-option *ngFor="let item of filterSettings" [value]="item">
                  {{item.name}}
                </mat-option>
              </mat-select>
              <mat-error>Select Filter
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
            <mat-form-field class="col-12"
             *ngIf="!fieldType[i] 
             || fieldType[i] && fieldType[i] == 0 
             || fieldType[i] && fieldType[i] == 2
             || fieldType[i] && fieldType[i] == 3">
              <mat-select placeholder="Filter Type" formControlName="filter">
                <mat-option value="">Select Operator</mat-option>
                <mat-option *ngFor="let item of filterType[i]" [value]="item.value">
                  {{item.name}}
                </mat-option>
              </mat-select>
              <mat-error>Select Operator
              </mat-error>
            </mat-form-field>
            <mat-form-field class="col-12" *ngIf="fieldType[i] && fieldType[i] == 1 ">
              <input matInput placeholder="From" [matDatepicker]="fromDatePicker" 
                formControlName="fromDate">
              <mat-datepicker-toggle matSuffix [for]="fromDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #fromDatePicker></mat-datepicker>
              <mat-error>Enter From Date</mat-error>
            </mat-form-field>           
          </div>
          <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
            <div class="row">
              <div class="col-10">
                <mat-form-field class="col-12" 
                *ngIf="!fieldType[i] || fieldType[i] && fieldType[i] == 0">
                  <input matInput placeholder="Value"  appInputText [config]="{format:reg}" formControlName="filtervalue" required>
                  <mat-error>Enter Value</mat-error>
                </mat-form-field>
                <mat-form-field class="col-12" *ngIf="fieldType[i] && fieldType[i] == 1 ">
                  <input matInput placeholder="To" [min] = "filterGroup.get('filterControls').controls[i].get('fromDate').value" [matDatepicker]="toDatePicker" 
                    formControlName="toDate">
                  <mat-datepicker-toggle matSuffix [for]="toDatePicker"></mat-datepicker-toggle>
                  <mat-datepicker #toDatePicker></mat-datepicker>
                  <mat-error>Enter From Date</mat-error>
                </mat-form-field>
                <mat-form-field class="col-12" *ngIf="fieldType[i] && fieldType[i] == 2 ">
                  <mat-select placeholder="Counter Party" formControlName="counterParty" >
                    <mat-option value="">Select Counter Party</mat-option>
                    <mat-option *ngFor="let item of orderTypes[i]" [value]="item.value">
                      {{item.name}}
                    </mat-option>                    
                  </mat-select>
                  <mat-error>Select Counter Party
                  </mat-error>
                </mat-form-field> 
                <mat-form-field class="col-12" *ngIf="fieldType[i] && fieldType[i] == 3 ">
                  <mat-select placeholder="Status" formControlName="status">
                    <mat-option value="">Select Value</mat-option>
                    <mat-option *ngFor="let item of status[i]" [value]="item.value">
                      {{item.name}}
                    </mat-option>                    
                  </mat-select>
                  <mat-error>Select Status
                  </mat-error>
                </mat-form-field>                 
              </div>
              <div class="col-2 p-0 d-flex align-items-center action_array">
                <button mat-button class="delete" (click)="removeFilter(i)"
                  *ngIf="filterGroup.get('filterControls').length > 1"> </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 mb-2">
        <button class="AddFilter"  (click)="addFilter()">+ Add Filter</button>
      </div>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
    <div class="d-flex w-100 justify-content-end px-3">
      <div class="mr-3">
        <button class="mx-1" mat-stroked-button color="primaryStrCus" (click)="closeModel()">CANCEL</button>
      </div>
      <!-- <div class="mx-3">
        <button class="mx-1" mat-raised-button color="primaryCus" [disabled]="filterGroup.status === 'INVALID'" (click)="savePreset()">SAVE PRESET</button>
        <button class="mx-1" mat-raised-button color="primaryCus"  (click)="removePreset()">REMOVE PRESET</button>
      </div> -->
      <div class="ml-3">
        <button (click)="resetFilter()"  mat-raised-button color="primaryCus">CLEAR
          FILTER</button>
        <button (click)="applyFilter()" [disabled]="!filterGroup.valid"  mat-raised-button color="primaryCus">APPLY
          FILTER</button>
      </div>
    </div>
</mat-dialog-actions>